import { render, staticRenderFns } from "./CouncilReportsAdmin.vue?vue&type=template&id=9709d454&scoped=true"
import script from "./CouncilReportsAdmin.vue?vue&type=script&lang=js"
export * from "./CouncilReportsAdmin.vue?vue&type=script&lang=js"
import style0 from "./CouncilReportsAdmin.vue?vue&type=style&index=0&id=9709d454&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9709d454",
  null
  
)

export default component.exports